import React from "react";
interface ProductDetailHeadingItemNumberProps {
  itemNumber: string;
  showVendorItemNumber: boolean;
  actualVendorItemNumber: string;
}
const ProductDetailHeadingItemNumber = ({
  itemNumber,
  showVendorItemNumber,
  actualVendorItemNumber
}: ProductDetailHeadingItemNumberProps) => {
  return <div className="flex" data-sentry-component="ProductDetailHeadingItemNumber" data-sentry-source-file="ProductDetailHeadingItemNumber.tsx">
      <span className="item-number">
        <span className="sr-only">Item number&nbsp; </span>
        <span aria-hidden="true">Item #:&nbsp;</span>
        <span className="uppercase">{itemNumber}</span>
      </span>
      {showVendorItemNumber && (actualVendorItemNumber?.length ?? 0) > 0 && <span className="mfr-number suffix_meta" data-itemnumber={itemNumber.toLocaleUpperCase()} data-testid="product-detail-heading-vendor-number">
          <span className="sr-only">MFR number&nbsp; </span>
          <span aria-hidden="true">MFR #:&nbsp;</span>
          <span className="uppercase">{actualVendorItemNumber}</span>
        </span>}
    </div>;
};
export default ProductDetailHeadingItemNumber;